module.exports = "mutation UploadImage {\n  uploadImage {\n    image {\n      ...UserImageFragment\n    }\n  }\n}\n"